import moment from 'moment';
import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from '../../../../../../../../shared/components/buttons/Button';
import {
  isIspbFiducia,
  returnStatusAnaliticData,
  setTypeOperation,
} from '../../../../../../../../utils/businessRule';
import { celMaskPhone, cpfCnpjMask } from '../../../../../../../../utils/masks';
import checkValue, {
  convertToReal,
} from '../../../../../../../../utils/values';
import { IBankInfoModal } from '../../interface';
import Info from './components/Info';
import Wrapper from './components/Wrapper';

function BankInfoModal(props: IBankInfoModal) {
  const { data } = props;

  return (
    <Modal
      show={props.show}
      onHide={props.onHide}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {data?.razao_social}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Wrapper.Base>
          {!(
            isIspbFiducia(data?.id_isbp_destino) &&
            isIspbFiducia(data?.id_ispb_origem)
          ) && (
            <>
              <Wrapper.Title>Dados Pessoais</Wrapper.Title>
              <Wrapper.Row margin="5px -15px 1rem">
                <Wrapper.Infocustom>
                  <Info.Label>Nome:</Info.Label>
                  <Info.Valueinput readOnly value={data?.nome_razaoSocial} />
                </Wrapper.Infocustom>
                <Wrapper.Infocustom>
                  <Info.Label>CPF:</Info.Label>
                  <Info.Valueinput
                    readOnly
                    value={cpfCnpjMask(String(data?.cpf_cnpj))}
                  />
                </Wrapper.Infocustom>
                <Wrapper.Infocustom>
                  <Info.Label>Data de nascimento:</Info.Label>
                  <Info.Valueinput
                    readOnly
                    value={
                      data?.data_nascimento
                        ? moment(data?.data_nascimento).format('DD/MM/YYYY')
                        : '-'
                    }
                  />
                </Wrapper.Infocustom>
                <Wrapper.Infocustom>
                  <Info.Label>Celular:</Info.Label>
                  <Info.Valueinput
                    readOnly
                    value={celMaskPhone(
                      String(data?.celular.replace(/\D/g, ''))
                    )}
                  />
                </Wrapper.Infocustom>
                <Wrapper.Infocustom>
                  <Info.Label>Email:</Info.Label>
                  <Info.Valueinput readOnly value={data?.email} />
                </Wrapper.Infocustom>
              </Wrapper.Row>
              <Wrapper.Divider />
            </>
          )}
          <Wrapper.Title>Transação</Wrapper.Title>
          <Wrapper.Row margin="5px -15px 1rem">
            <Wrapper.Infocustom>
              <Info.Label>Valor:</Info.Label>
              <Info.Valueinput
                readOnly
                value={convertToReal(Number(data?.valor_lancamento))}
              />
            </Wrapper.Infocustom>
            <Wrapper.Infocustom width="40%">
              <Info.Label>Tipo da Transação:</Info.Label>
              <Info.Valueinput
                readOnly
                value={data?.cod_msg === 'Pix' ? 'PIX' : data?.cod_msg}
              />
            </Wrapper.Infocustom>
            <Wrapper.Infocustom>
              <Info.Label>Data Movimento:</Info.Label>
              <Info.Valueinput
                readOnly
                value={moment(data?.created_at).format('DD/MM/YYYY')}
              />
            </Wrapper.Infocustom>
            <Wrapper.Infocustom>
              <Info.Label>Data Registro:</Info.Label>
              <Info.Valueinput
                value={moment(data?.created_at).format('DD/MM/YYYY')}
              />
            </Wrapper.Infocustom>
          </Wrapper.Row>
          <Wrapper.Row margin="5px -15px 1rem">
            <Wrapper.Infocustom>
              <Info.Label>Horário Registro:</Info.Label>
              <Info.Valueinput
                value={moment(data?.created_at).format('HH:mm:ss')}
              />
            </Wrapper.Infocustom>
            <Wrapper.Infocustom>
              <Info.Label>Horário Retorno:</Info.Label>
              <Info.Valueinput
                value={moment(data?.created_at).format('HH:mm:ss')}
              />
            </Wrapper.Infocustom>
          </Wrapper.Row>
          <Wrapper.Title>Debitado</Wrapper.Title>
          <Wrapper.Row margin="5px -15px 1rem">
            <Wrapper.Infocustom>
              <Info.Label>ISPB ID:</Info.Label>
              <Info.Valueinput value={data?.ISPBIFDebtd} />
            </Wrapper.Infocustom>
          </Wrapper.Row>
          <Wrapper.Row margin="5px -15px 1rem">
            <Wrapper.Infocustom width="50%">
              <Info.Label>Cliente:</Info.Label>
              <Info.Valueinput value={data?.nome_cliente_debito} />
            </Wrapper.Infocustom>
            <Wrapper.Infocustom width="30%">
              <Info.Label>CPF/CNPJ:</Info.Label>
              <Info.Valueinput
                value={cpfCnpjMask(checkValue(String(data?.cnpj_cpf_debito)))}
              />
            </Wrapper.Infocustom>
            <Wrapper.Infocustom>
              <Info.Label>Conta:</Info.Label>
              <Info.Valueinput value={data?.ctDebtd} />
            </Wrapper.Infocustom>
            <Wrapper.Infocustom width="120px">
              <Info.Label>Agência:</Info.Label>
              <Info.Valueinput value={data?.agDebtd} />
            </Wrapper.Infocustom>
            <Wrapper.Infocustom width="170px">
              <Info.Label>Tipo de Conta:</Info.Label>
              <Info.Valueinput value={data?.tpCtDebitada} />
            </Wrapper.Infocustom>
          </Wrapper.Row>
          <Wrapper.Title>Creditado</Wrapper.Title>
          <Wrapper.Row margin="5px -15px 1rem">
            <Wrapper.Infocustom>
              <Info.Label>ISPB ID Creditádo:</Info.Label>
              <Info.Valueinput value={data?.ISPBIFCredtd} />
            </Wrapper.Infocustom>
          </Wrapper.Row>
          <Wrapper.Row margin="5px -15px 1rem">
            <Wrapper.Infocustom width="50%">
              <Info.Label>Cliente:</Info.Label>
              <Info.Valueinput value={data?.nome_clienteCredtada} />
            </Wrapper.Infocustom>
            <Wrapper.Infocustom width="30%">
              <Info.Label>CPF/CNPJ:</Info.Label>
              <Info.Valueinput
                value={cpfCnpjMask(
                  checkValue(String(data?.cnpj_cpf_clienteCredtada))
                )}
              />
            </Wrapper.Infocustom>
            <Wrapper.Infocustom>
              <Info.Label>Conta:</Info.Label>
              <Info.Valueinput value={data?.ctCredtda} />
            </Wrapper.Infocustom>
            <Wrapper.Infocustom width="120px">
              <Info.Label>Agência:</Info.Label>
              <Info.Valueinput value={data?.agCredtda} />
            </Wrapper.Infocustom>
            <Wrapper.Infocustom width="170px">
              <Info.Label>Tipo de Conta:</Info.Label>
              <Info.Valueinput value={data?.tpCtCredtda} />
            </Wrapper.Infocustom>
          </Wrapper.Row>
          <Wrapper.Row margin="5px -15px 1rem">
            <Wrapper.Infocustom width="100%">
              <Info.Label>Descrição:</Info.Label>
              <Info.Valueinput value={data?.hist} />
            </Wrapper.Infocustom>
          </Wrapper.Row>
          <Wrapper.Row margin="5px -15px 1rem">
            <Wrapper.Infocustom>
              <Info.Label>Status:</Info.Label>
              <Info.Valueinput
                value={returnStatusAnaliticData(String(data?.TpRetorno))}
              />
            </Wrapper.Infocustom>
            <Wrapper.Infocustom>
              <Info.Label>Protocolo de remessa:</Info.Label>
              <Info.Valueinput
                value={
                  data?.protocolo_remessas ? data?.protocolo_remessas : '-'
                }
              />
            </Wrapper.Infocustom>
            <Wrapper.Infocustom>
              <Info.Label>Identificador:</Info.Label>
              <Info.Valueinput
                value={
                  data?.transaction_identification
                    ? data?.transaction_identification
                    : '-'
                }
              />
            </Wrapper.Infocustom>
            <Wrapper.Infocustom>
              <Info.Label>Finalidade:</Info.Label>
              <Info.Valueinput value={data?.finalidade} />
            </Wrapper.Infocustom>
            <Wrapper.Infocustom>
              <Info.Label>Tipo de operação:</Info.Label>
              <Info.Valueinput
                value={data?.cod_msg + setTypeOperation(data?.cod_msg)}
              />
            </Wrapper.Infocustom>
          </Wrapper.Row>
          <Wrapper.Divider />
          <Wrapper.Title>Open Finance</Wrapper.Title>
          <Wrapper.Row margin="5px -15px 1rem">
            <Wrapper.Infocustom>
              <Info.Label>Protocolo Remessas:</Info.Label>
              <Info.Valueinput
                value={
                  data?.protocolo_remessas ? data?.protocolo_remessas : '-'
                }
              />
            </Wrapper.Infocustom>
            <Wrapper.Infocustom>
              <Info.Label>Identificador:</Info.Label>
              <Info.Valueinput
                value={data?.identificador ? data?.identificador : '-'}
              />
            </Wrapper.Infocustom>
            <Wrapper.Infocustom>
              <Info.Label>Consent ID:</Info.Label>
              <Info.Valueinput
                value={data?.consent_id ? data?.consent_id : '-'}
              />
            </Wrapper.Infocustom>
            <Wrapper.Infocustom>
              <Info.Label>CNPJ do Iniciador:</Info.Label>
              <Info.Valueinput
                value={data?.cnpj_initiator ? data?.cnpj_initiator : '-'}
              />
            </Wrapper.Infocustom>
            <Wrapper.Infocustom>
              <Info.Label>Código do município:</Info.Label>
              <Info.Valueinput
                value={data?.ibge_town_code ? data?.ibge_town_code : '-'}
              />
            </Wrapper.Infocustom>
          </Wrapper.Row>
          <Wrapper.Row margin="5px -15px 1rem">
            <Wrapper.Infocustom>
              <Info.Label>Transaction Identification:</Info.Label>
              <Info.Valueinput
                value={
                  data?.transaction_identification
                    ? data?.transaction_identification
                    : '-'
                }
              />
            </Wrapper.Infocustom>
            <Wrapper.Infocustom>
              <Info.Label>Tipo de iniciação:</Info.Label>
              <Info.Valueinput
                value={data?.tp_iniciacao ? data?.tp_iniciacao : '-'}
              />
            </Wrapper.Infocustom>
            <Wrapper.Infocustom>
              <Info.Label>ID da Transação:</Info.Label>
              <Info.Valueinput value={data?.id ? data?.id : '-'} />
            </Wrapper.Infocustom>
            <Wrapper.Infocustom>
              <Info.Label>Número crtIF:</Info.Label>
              <Info.Valueinput
                value={data?.numCtrlIF ? data?.numCtrlIF : '-'}
              />
            </Wrapper.Infocustom>
            <Wrapper.Infocustom>
              <Info.Label>Número crtlSTR:</Info.Label>
              <Info.Valueinput
                value={data?.NumCtrlSTR ? data?.NumCtrlSTR : '-'}
              />
            </Wrapper.Infocustom>
          </Wrapper.Row>
        </Wrapper.Base>
      </Modal.Body>
      <Modal.Footer
        style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
        <Button.Default onClick={props.onHide}>Fechar</Button.Default>
      </Modal.Footer>
    </Modal>
  );
}

export default BankInfoModal;
